<!-- {{ message | async | json }} -->
<div class="success_meassage zoom" *ngIf="showSuccessMessage">
  <img src="../../../../../assets/image/checked64.png" alt="" />
</div>
<div class="wrapper">
  <form [formGroup]="qrForm">
    <div class="mb-3">
      <label for="amount" class="form-label">{{
        "qrModal.amount" | translate
      }}</label>
      <input
        type="text"
        class="form-control"
        id="amount"
        suffix=" ֏"
        mask="separator.2"
        thousandSeparator=","
        formControlName="amount"
        onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
      />
    </div>
    <div class="mb-3">
      <label for="comment" class="form-label">{{
        "qrModal.comment" | translate
      }}</label>
      <textarea
        class="form-control"
        id="comment"
        rows="3"
        formControlName="comment"
      ></textarea>
    </div>
    <div class="mb-3 sw-btn" *ngIf="canGenerateMultiQR">
      <label for="multi" class="form-label">{{
        "qrModal.isMulti" | translate
      }}</label>
      <label class="switch" id="multi">
        <input
          type="checkbox"
          formControlName="isMulti"
          (change)="amDisable($event)"
        />
        <span class="slider round"></span>
      </label>
    </div>
    <div class="mb-3 sw-btn" *ngIf="!canGenerateMultiQR">
      <label for="multi" class="form-label">{{
        "qrModal.isMulti" | translate
      }}</label>
      <label class="switch" id="multi">
        <input
          disabled
          type="checkbox"
          formControlName="isMulti"
          (change)="amDisable($event)"
        />
        <span class="slider round"></span>
      </label>
    </div>
    <button
      class="btn btn-success"
      [disabled]="qrForm.get('amount').value == 0"
      (click)="generateQR(contactForNextTemplate)"
    >
      {{ "qrModal.button" | translate }}
    </button>
  </form>

  <!-- <div (appClickOutSide)="someF()" [isOpened]="showQr" class="qr-modal" [ngClass]="{dis:showQr}">
    <div class="spinner-grow text-warning" *ngIf="loading"></div>
    <div class="main-modal">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;"
        xml:space="preserve" (click)="dissmiss()">
        <g>
          <g>
            <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                L284.286,256.002z" />
          </g>
        </g>
      </svg>
      <div class="header" *ngIf="!loading">
        <h3 *ngIf="amountValue != 0">{{'qrModal.amount' | translate}}` {{this.amountValue}}</h3>
        <qr-code value="{{qrCode}}" size="200" errorCorrectionLevel="M"></qr-code>
      </div>
      <div class="footer" *ngIf="!loading">
        <div class="alert alert-secondary text-center" role="alert" *ngIf="copied">
          Պատճենված է
        </div>
        <button class="btn btn-success" (click)="copyLink()">Պատճենեք հղումը և ուղարկեք վճարողին</button>
        <button class="btn btn-success" data-bs-toggle="modal" data-bs-target="#phoneModal">Ուղարկել վճարման հարցում
          SMS</button>
      </div>
    </div>
  </div> -->

  <button
    type="button"
    #qr_modal
    class="btn btn-primary hidden_button"
    data-bs-toggle="modal"
    data-bs-target="#qr-modal"
  ></button>

  <div
    class="modal fade"
    id="qr-modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="qr-modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">QR</h5>
          <button
            type="button"
            #close_modal_qr
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="dissmiss()"
          ></button>
        </div>
        <div class="modal-body">
          <div class="my-modal-body">
            <div
              class="spinner-grow text-warning my-color"
              *ngIf="loading"
            ></div>
          </div>
          <div class="header" *ngIf="!loading">
            <h3>
              {{ "qrModal.amount" | translate }}`
              {{ this.amountValue | number : ".2" }}
            </h3>
            <div class="qr-image-wrapper">
              <ng-container *ngIf="canGenerateQR">
                <qr-code
                  value="{{ qrCode }}"
                  size="200"
                  errorCorrectionLevel="M"
                ></qr-code>
                <div class="wh">
                  <img
                    src="../../../../../assets/image/new-deals/arca_a.png"
                    alt=""
                  />
                </div>
              </ng-container>
            </div>

            <!--  -->
          </div>
          <div class="modal-footer" *ngIf="!loading">
            <div class="cop">
              <!-- <div class="alert alert-secondary text-center" role="alert" *ngIf="copied">
                {{'qrModal.copied' | translate}}
              </div> -->
              <button
                *ngIf="canGenerateLink"
                class="btn btn-success btn-for-qr"
                (click)="copyLink()"
                data-bs-toggle="modal"
                data-bs-target="#qrlink"
                data-bs-dismiss="modal"
              >
                {{ "qrModal.copyLinkAndSend" | translate }}
              </button>
            </div>
            <!-- <div class="sms">
              <button class="btn btn-success btn-for-qr btn-for-qr-y" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#phoneModal">
                {{'qrModal.sendSMSRequest' | translate}}
              </button>
            </div> -->
            <!-- <div class="cop">
              <button class="btn btn-success btn-for-qr btn-for-qr-y" data-bs-dismiss="modal" data-bs-toggle="modal"
                data-bs-target="#payxUser">
                {{'qrModal.sendSMSRequestPayx' | translate}}
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="modal fade" id="phoneModal" tabindex="-1" aria-labelledby="phoneModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <label for="phoneNumber" class="form-label">Phone Number</label>
          <input type="text" class="form-control" prefix="+374" mask="00 00 00 00" [(ngModel)]="phoneNumber"
            id="phoneNumber" onkeydown="return event.keyCode !== 69 && event.keyCode !== 189">
          <div class="alert alert-danger mt-3" *ngIf="invalidPhoneNumber" role="alert">
            Invalid Phone Number
          </div>
          <div class="alert alert-success mt-3" *ngIf="successPhone" role="alert">
            The link has sended
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" #closeModal data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-success" [disabled]="!sendSmsButton" (click)="sendSMS()">Send
            SMS</button>
        </div>
      </div>
    </div>
  </div> -->
  <div
    class="phone-modal modal fade"
    id="phoneModal"
    tabindex="-1"
    aria-labelledby="phoneModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- <div class="modal-header">
            <h5 class="modal-title" id="phoneModalLabel">Modal title</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div> -->
        <div class="modal-body">
          <label for="phoneNumber" class="form-label">{{
            "qrModal.phoneNumber" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            prefix="+374"
            mask="00 00 00 00"
            [(ngModel)]="phoneNumber"
            id="phoneNumber"
            onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
          />
          <div
            class="alert alert-danger mt-3"
            *ngIf="invalidPhoneNumber"
            role="alert"
          >
            {{ "qrModal.invalidPhone" | translate }}
          </div>
          <div
            class="alert alert-success mt-3"
            *ngIf="successPhone"
            role="alert"
          >
            {{ "qrModal.sended" | translate }}
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            #closeModal
            data-bs-dismiss="modal"
          >
            {{ "qrModal.close" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            [disabled]="!sendSmsButton"
            (click)="sendSMS()"
          >
            {{ "qrModal.sendSMS" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="payxUser"
    tabindex="-1"
    aria-labelledby="payxUserLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="phoneModalLabel">
            {{ "qrModal.sendSMSRequestPayx" | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <label for="phoneNumber" class="form-label">{{
            "qrModal.phoneNumber" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            prefix="+374"
            mask="00 00 00 00"
            [(ngModel)]="phoneNumber"
            id="phoneNumber"
            onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
          />
          <div
            class="alert alert-danger mt-3"
            *ngIf="invalidPhoneNumber"
            role="alert"
          >
            {{ "qrModal.invalidPhone" | translate }}
          </div>
          <div
            class="alert alert-success mt-3"
            *ngIf="successPhone"
            role="alert"
          >
            {{ "qrModal.sended" | translate }}
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            #closePayxUserModal
            data-bs-dismiss="modal"
          >
            {{ "qrModal.close" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-success"
            [disabled]="!sendSmsButton"
            (click)="sendPayxUSer()"
          >
            {{ "qrModal.send" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="qrlink"
    tabindex="-1"
    aria-labelledby="qrlinkLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="phoneModalLabel">QR LINK</h5>
          <button
            type="button"
            #closeQrLink
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body qr-body">
          <div class="qr-image-wrapper">
            <qr-code
              value="{{ this.link }}"
              size="200"
              errorCorrectionLevel="M"
            ></qr-code>
            <div class="wh">
              <img
                src="../../../../../assets/image/new-deals/arca_a.png"
                alt=""
              />
            </div>
          </div>

          <div
            class="alert alert-secondary text-center"
            role="alert"
            *ngIf="copied"
          >
            {{ "qrModal.copied" | translate }}
          </div>
          <!-- <p>{{this.link}}</p> -->
        </div>
        <div class="modal-footer my-modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            #closeModal
            data-bs-dismiss="modal"
          >
            {{ "qrModal.close" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #contactForNextTemplate>
  <span class="em"> Համակարգից օգտվելու համար դիմեք մեզ </span>
</ng-template>
